var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowAudioBtn)?_c('div',{staticClass:"video-wrapper"},[_c('audio',{ref:"audio",staticClass:"video",attrs:{"controls":"","name":"media"}},[_c('source',{attrs:{"src":_vm.audioSrc,"type":"audio/wav"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }